import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Button } from "./ui/button";
import { Switch } from "./ui/switch";
import { Slider } from "./ui/slider";
import { Layers } from "lucide-react";

const LAYER_META = [
  { k: "plates", label: "Batas Lempeng Tektonik", color: "bg-sky-400" },
  { k: "faults", label: "Megathrust & Patahan", color: "bg-red-500" },
  { k: "volcanoes", label: "Gunung Api Aktif", color: "bg-amber-500" },
  { k: "wildfires", label: "Titik Panas Karhutla", color: "bg-orange-500" },
];

export default function LayersMenu({ layers, setLayers, filters, setFilters }) {
  const activeCount = Object.values(layers).filter(Boolean).length;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button size="sm" variant="ghost" className="hover:bg-slate-900" data-testid="layers-menu-btn">
          <Layers className="mr-1.5 h-4 w-4" />
          <span className="hidden md:inline">Layer</span>
          <span className="ml-1.5 rounded-md bg-slate-800 px-1.5 py-0.5 font-mono text-[10px] text-cyan-400">{activeCount}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 border-2 border-slate-700 bg-slate-900 p-3 text-slate-100 shadow-2xl" data-testid="layers-menu-content">
        <div className="mb-2 text-[10px] font-bold uppercase tracking-widest text-slate-400">Layer Geospatial</div>
        <div className="space-y-1.5">
          {LAYER_META.map((l) => (
            <label key={l.k} className="flex cursor-pointer items-center justify-between rounded-md bg-slate-950/60 px-2.5 py-1.5 hover:bg-slate-950">
              <div className="flex items-center gap-2">
                <span className={`h-2 w-2 rounded-full ${l.color}`}></span>
                <span className="text-xs text-slate-200">{l.label}</span>
              </div>
              <Switch checked={layers[l.k]} onCheckedChange={(v) => setLayers({ ...layers, [l.k]: v })} data-testid={`nav-layer-toggle-${l.k}`} />
            </label>
          ))}
        </div>
        {layers.wildfires && (
          <div className="mt-3 space-y-2 rounded-md border border-slate-800 bg-slate-950/40 p-2">
            <div className="text-[9px] font-bold uppercase tracking-widest text-slate-400">Filter Titik Api</div>
            <div className="flex gap-1">
              {[
                { id: "southeast_asia", label: "Indonesia / SEA" },
                { id: "global", label: "Global" },
              ].map((r) => (
                <button
                  key={r.id}
                  onClick={() => setFilters({ ...filters, fireRegion: r.id })}
                  className={`flex-1 rounded px-2 py-1 text-[10px] font-semibold ${filters.fireRegion === r.id ? "bg-orange-500 text-slate-950" : "bg-slate-900 text-slate-300 hover:bg-slate-800"}`}
                  data-testid={`nav-fire-region-${r.id}`}
                >{r.label}</button>
              ))}
            </div>
            <div>
              <div className="mb-1 flex items-center justify-between">
                <span className="text-[9px] font-bold uppercase tracking-widest text-slate-400">Min FRP</span>
                <span className="font-mono text-[10px] text-orange-400">{filters.minFrp} MW</span>
              </div>
              <Slider min={0} max={100} step={5} value={[filters.minFrp]} onValueChange={(v) => setFilters({ ...filters, minFrp: v[0] })} data-testid="nav-filter-min-frp" />
            </div>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
